import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import EraType from '@/roc/era/EraType';

const Alhambra = {
  id: '69',
  name: 'Alhambra',
  era: EraType.earlyRome,
  icon: 'alhambra',
  gameId: 'Alhambra',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.STORIES_AND_MYTHS,
  kind: WonderKind.FORTRESS | WonderKind.NATURE,
  kindMultiplier: 1,
  owner: WonderOwner.CAPITAL,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.LIGHT_INFANTRY_CRITICAL_HIT_CHANCE_MOD,
      EffectAmount.asPerLevel([
        40.0,
        60.0,
        77.0,
        91.0,
        104.0,  // 5
        116.0,
        127.0,
        137.0,
        147.0,
        157.0, // 10
        166.0,
        174.0,
        183.0,
        191.0,
        199.0, // 15
        207.0,
        214.0,
        222.0,
        229.0,
        236.0, // 20
        243.0,
        250.0,
        256.0,
        263.0,
        269.0,   // 25
        276.0,
        282.0,
        288.0,
        294.0,
        300.0  // 30
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asFlat(1)
        .withOutput(ProductionOutputType.EVENT_CURRENCY)
        .withDescription('Produce event currency or research points.')
      ,
    ),
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asCallbackWithLevel(
        function (level) {
          if (level === 30) {
            return 4;
          }
          if (level >= 20) {
            return 3;
          }
          if (level >= 10) {
            return 2;
          }
          return 1;
        }
      ),
    ),
  ]),
  synergies: [],
};

export default Alhambra;
